import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import ChecklistActions from '../actions/checklist.actions';
import ShiftActions from '../actions/shift.actions';

export function* getChecklistRequest(api, action) {
  const { roleId, category } = action;
  const response = yield api.getChecklist(roleId, category);
  if (response && response.ok) {
    yield put(ChecklistActions.getChecklistSuccess(response.data, category));
  } else {
    yield put(ChecklistActions.getChecklistFailure());
  }
}

export function* getChecklistByCategoryRequest(api, action) {
  const { category } = action;
  const response = yield api.getChecklistByCategory(category);
  if (response && response.ok) {
    yield put(ChecklistActions.getChecklistByCategorySuccess(response.data, category));
  } else {
    yield put(ChecklistActions.getChecklistByCategoryFailure());
  }
}

export function* createChecklistItemRequest(api, action) {
  const { payload } = action;
  const response = yield api.createChecklistItem(payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Checklist Item was created successfully', response);
    yield put(ChecklistActions.createChecklistItemSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to create Checklist Item', response);
    yield put(ChecklistActions.createChecklistItemFailure());
  }
}

export function* createChecklistItemsMultipleRequest(api, action) {
  const { payload } = action;
  const response = yield api.createChecklistItemsMultiple(payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Checklist Items are created successfully', response);
    yield put(ChecklistActions.createChecklistItemsMultipleSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to create Checklist Item', response);
    yield put(ChecklistActions.createChecklistItemsMultipleFailure());
  }
}

export function* editChecklistItemRequest(api, action) {
  const { checklistItemId, payload } = action;
  const response = yield api.editChecklistItem(checklistItemId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Checklist Item was updated successfully', response);
    yield put(ChecklistActions.editChecklistItemSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to update checklist item', response);
    yield put(ChecklistActions.editChecklistItemFailure(checklistItemId));
  }
}

export function* deleteChecklistItemRequest(api, action) {
  const { checklistItemId, category } = action;
  const response = yield api.deleteChecklistItem(checklistItemId);
  if (response && response.ok) {
    InsighttNotification('success', 'Checklist Item was deleted successfully', response);
    yield put(ChecklistActions.deleteChecklistItemSuccess(checklistItemId, category));
  } else {
    InsighttNotification('error', 'Unable to delete Checklist Item', response);
    yield put(ChecklistActions.deleteChecklistItemFailure(checklistItemId));
  }
}

export function* submitUserNTChecklistRequest(api, action) {
  const { payload } = action;
  const response = yield api.submitUserNTChecklist(payload);

  if (response && response.ok) {
    yield put(ChecklistActions.submitUserNTChecklistSuccess(response.data));
    InsighttNotification('success', 'User Checklist submitted successfully', response);
  } else {
    yield put(ChecklistActions.submitUserNTChecklistFailure());
    InsighttNotification('error', 'Unable to submit user checklist', response);
  }
}

export function* fetchUserChecklistRequest(api, action) {
  const { id } = action;
  const response = yield api.fetchUserChecklist(id);

  if (response && response.ok) {
    yield put(ChecklistActions.fetchUserChecklistSuccess(response.data));
  } else {
    yield put(ChecklistActions.fetchUserChecklistFailure());
    InsighttNotification('error', 'Unable to submit user checklist', response);
  }
}

export function* getUserNTChecklistRequest(api, action) {
  const { userId } = action;
  const response = yield api.getUserNTChecklist(userId);
  if (response && response.ok) {
    if (!response.data.checklist) {
      InsighttNotification('warning', 'This User has no checklist submitted', null);
    }
    yield put(ChecklistActions.getUserNTChecklistSuccess(userId, response.data));
  } else {
    yield put(ChecklistActions.getUserNTChecklistFailure(userId));
    InsighttNotification('error', 'Unable to get user checklist', response);
  }
}

export function* submitStartShiftChecklistRequest(api, action) {
  const response = yield api.submitUserShiftChecklist(action.payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Start of Shift Checklist was submitted successfully', response);
    /*
      If the request is OK, then we modify the status to allow access to any view,
      as this field, if false, allows redirecting to /dashboard until the checklist form is completed.
    */
    yield put(ShiftActions.changeShiftCheckListStatus(true));
    yield put(ChecklistActions.submitStartShiftChecklistSuccess());
  } else {
    InsighttNotification('error', 'Unable to submit start of shift checklist', response);
    yield put(ChecklistActions.submitStartShiftChecklistFailure());
  }
}

export function* submitEndShiftChecklistRequest(api, action) {
  const response = yield api.submitUserShiftChecklist(action.payload);
  if (response && response.ok) {
    InsighttNotification('success', 'End of Shift Checklist was submitted successfully', response);
    yield put(ChecklistActions.submitEndShiftChecklistSuccess());
  } else {
    InsighttNotification('error', 'Unable to submit end of shift checklist', response);
    yield put(ChecklistActions.submitEndShiftChecklistFailure());
  }
}

export function* getUserShiftChecklistRequest(api, action) {
  const { userId, shiftTimeId, category } = action;
  const response = yield api.getUserShiftChecklist(userId, shiftTimeId, category);
  if (response && response.ok) {
    yield put(ChecklistActions.getUserShiftChecklistSuccess(response.data, category));
  } else {
    yield put(ChecklistActions.getUserShiftChecklistFailure());
  }
}
